export default __webpack_public_path__ + "static/media/vip11.bfd9c15f.webp";